import React from 'react';
import { Button } from 'ui';

const RetakeLessonReassign = ({ ...props }) => {
  return (
    <div>
      {props.lessonMaximumAttempts > 0 &&
        (props.maximumAttemptsLimitCheck ? (
          <h2>
            {t('learning.lessons.retake.try_again_with_attempts', {
              total_attempts: props.totalAttempts,
            })}
          </h2>
        ) : (
          <h2>{t('learning.lessons.retake.inform_manager')}</h2>
        ))}
      {props.lessonMaximumAttempts < 1 && (
        <h2>{t('learning.lessons.retake.try_again')}</h2>
      )}
      {props.backToPathHTMLLink &&
        props.totalAttempts < 1 &&
        props.lessonMaximumAttempts > 0 && (
          <Button customColor url={props.backToPathHTMLLink}>
            {t('learning.lessons.retake.back_to_path')}
          </Button>
        )}
    </div>
  );
};

export default RetakeLessonReassign;
